"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable array-callback-return */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const styles_1 = require("@material-ui/core/styles");
const AppBar_1 = __importDefault(require("@material-ui/core/AppBar"));
const Avatar_1 = __importDefault(require("@material-ui/core/Avatar"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const Toolbar_1 = __importDefault(require("@material-ui/core/Toolbar"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
const clsx_1 = __importDefault(require("clsx"));
const styles = (theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.common.white,
    },
    siteTitle: {
        padding: '0',
        fontSize: '1.75rem !important',
    },
    menuButton: {
        color: `${theme.palette.text.primary}80`,
    },
    active: {
        fontWeight: 900,
    },
    listItems: {
        flexGrow: 1,
    },
    navBorder: {
        borderBottom: `solid 1px ${theme.palette.secondary.dark}`,
        boxShadow: '0',
    },
    staticHomeBar: {
        flexGrow: 1,
        color: theme.palette.common.white,
        boxShadow: '0',
        backgroundColor: theme.palette.secondary.main,
    },
    staticHomeText: {
        color: theme.palette.common.white,
    },
    avatar: {
        backgroundColor: theme.palette.text.primary,
        cursor: 'pointer',
        fontSize: '1rem',
    },
    linkSpacing: {
        marginRight: '0.875rem',
        fontSize: '1rem',
    },
    divider: {
        backgroundColor: '#000',
        marginTop: '1.25rem',
        marginBottom: '1.25rem',
    },
    staticDivider: {
        backgroundColor: '#fff',
        marginTop: '1.25rem',
        marginBottom: '1.25rem',
    },
    loginButton: {
        color: theme.palette.primary.main,
        fontSize: '1.1rem',
    },
});
function DenseAppBar(props) {
    const { authActionSubmit, classes, links, loggedIn, userInitials, isStaticHome } = props;
    const [currentPath, setCurrentPath] = (0, react_1.useState)('');
    (0, react_1.useEffect)(() => {
        setCurrentPath(typeof window !== 'undefined' ? window.location.pathname : '');
    });
    return (react_1.default.createElement("div", { className: !isStaticHome ? classes.root : classes.homeRoot },
        react_1.default.createElement(AppBar_1.default, { position: "static", color: "inherit", className: !isStaticHome ? classes.navBorder : classes.staticHomeBar, elevation: 0 },
            react_1.default.createElement(core_1.Container, { maxWidth: "lg" },
                react_1.default.createElement(Toolbar_1.default, { disableGutters: true },
                    react_1.default.createElement(Typography_1.default, { variant: "h3", color: "inherit", className: (0, clsx_1.default)(classes.linkSpacing, classes.siteTitle) }, "EISC"),
                    !isStaticHome ? (react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true, variant: "middle", classes: { vertical: classes.divider } })) : null,
                    react_1.default.createElement("div", { className: classes.listItems },
                        react_1.default.createElement("div", null, links.map((link, i) => {
                            if (link.visible || typeof link.visible !== 'boolean') {
                                return (react_1.default.createElement(react_1.default.Fragment, { key: i }, link.onClick ? (react_1.default.createElement(Button_1.default, { color: "inherit", onClick: () => link.onClick(), className: (0, clsx_1.default)(!isStaticHome ? classes.menuButton : classes.staticHomeText, link.value === currentPath && classes.active, classes.linkSpacing) }, link.title)) : (react_1.default.createElement(Button_1.default, { color: "inherit", href: link.value, target: link.target || undefined, className: (0, clsx_1.default)(!isStaticHome ? classes.menuButton : classes.staticHomeText, link.value === currentPath && classes.active, classes.linkSpacing) }, link.title))));
                            }
                        }))),
                    loggedIn && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Avatar_1.default, { className: classes.avatar, onClick: () => props.onUserInitialClick() }, userInitials),
                        react_1.default.createElement(Divider_1.default, { orientation: "vertical", flexItem: true, variant: "middle", classes: { vertical: !isStaticHome ? classes.divider : classes.staticDivider } }))),
                    react_1.default.createElement(Button_1.default, { className: classes.loginButton, onClick: authActionSubmit }, loggedIn ? 'Log Out' : 'Login'))))));
}
DenseAppBar.propTypes = {
    authActionSubmit: prop_types_1.default.func.isRequired,
    classes: prop_types_1.default.object.isRequired,
    links: prop_types_1.default.arrayOf(prop_types_1.default.any),
    loggedIn: prop_types_1.default.bool.isRequired,
    userInitials: prop_types_1.default.string,
    onUserInitialClick: prop_types_1.default.func,
    isStaticHome: prop_types_1.default.bool,
};
exports.default = (0, styles_1.withStyles)(styles)(DenseAppBar);
